"use client"

import { createContext, useContext, type ReactNode } from "react"

/**
 * Si el Mercado está abierto, para los componentes de cliente de la web
 * (la cabecera, el pie). Lo pone el layout raíz con lo que diga
 * lib/mercado/visible.ts.
 */
const MercadoVisible = createContext(false)

export function MercadoVisibleProvider({ activo, children }: { activo: boolean; children: ReactNode }) {
  return <MercadoVisible.Provider value={activo}>{children}</MercadoVisible.Provider>
}

export function useMercadoVisible(): boolean {
  return useContext(MercadoVisible)
}

/** Lo que solo se enseña con el Mercado abierto. */
export function SoloConMercado({ children }: { children: ReactNode }) {
  return useMercadoVisible() ? <>{children}</> : null
}
